import * as R from 'ramda';

const cyrb53 = (str, seed = 0) => {
    let h1 = 0xdeadbeef ^ seed, h2 = 0x41c6ce57 ^ seed;
    for(let i = 0, ch; i < str.length; i++) {
        ch = str.charCodeAt(i);
        h1 = Math.imul(h1 ^ ch, 2654435761);
        h2 = Math.imul(h2 ^ ch, 1597334677);
    }
    h1  = Math.imul(h1 ^ (h1 >>> 16), 2246822507);
    h1 ^= Math.imul(h2 ^ (h2 >>> 13), 3266489909);
    h2  = Math.imul(h2 ^ (h2 >>> 16), 2246822507);
    h2 ^= Math.imul(h1 ^ (h1 >>> 13), 3266489909);
  
    return 4294967296 * (2097151 & h2) + (h1 >>> 0);
};

export default function ActivityLog(data) {
    const activityLog = data || {};
    this.userId = activityLog.userId;
    this.userName = activityLog.userName;
    this.description = activityLog.activityDescription;
    this.date = new Date(activityLog.date);
    this.operatorId = activityLog.operatorId;
    this.operatorName = activityLog.operatorName;
    this.partnerId = activityLog.partnerId;
    this.id = cyrb53(this.date.toISOString()+this.partnerId+this.userId+this.operatorId+this.description);
}